import type { IntegrationSettings } from '@entities/integration';
import type { IntegrationsettingUpdateReceivedPayload } from '@main/event-listeners/payloads/integration-setting-update-received.payload';

import type { BaseUsecase } from '@usecases/base-usecase';

export type SyncIntegrationSettingUpdateRequest =
  IntegrationsettingUpdateReceivedPayload;
export type SyncIntegrationSettingUpdateResponse = void;

export interface SyncIntegrationSettingUpdateRepository {
  saveSetting(setting: IntegrationSettings): Promise<void>;
  getSettingsById(
    integrationId: number,
  ): Promise<IntegrationSettings | undefined>;
}

export type SyncIntegrationSettingUpdateUsecase = BaseUsecase<
  SyncIntegrationSettingUpdateRequest,
  SyncIntegrationSettingUpdateResponse
>;

export class SyncIntegrationSettingUpdate
  implements SyncIntegrationSettingUpdateUsecase
{
  constructor(private repository: SyncIntegrationSettingUpdateRepository) {}

  async run(
    settings: SyncIntegrationSettingUpdateRequest,
  ): Promise<SyncIntegrationSettingUpdateResponse> {
    const { integration_id, integration_settings: updatedIntegrationSettings } =
      settings;

    const currentSetting = await this.repository.getSettingsById(
      integration_id,
    );
    if (!currentSetting) {
      return;
    }

    const updatedSettings: IntegrationSettings = {
      ...updatedIntegrationSettings,
      instanceUrl: currentSetting.instanceUrl,
      integrationId: integration_id,
    };

    await this.repository.saveSetting(updatedSettings);
    return;
  }
}
